export default __webpack_public_path__ + "static/media/keidar1.8688d843.jpg";